import createLogger from '~/src/Lib/Logging'
import TaskViewComments from '~/src/Note/shared/ViewComments'
import ViewInstruction from '~/src/Note/shared/ViewInstruction'

import TaskViewAssignees from './TaskViewAssignees'

const displayName = 'Task/View/utils'
const logger = createLogger(displayName)

export const behaviorToEntity = {
  PEST: 'pesticideApplication',
}

export const TASK_VIEW_TABS = ['instruction', 'assigned', 'schedule', 'comments']

export const tabToComponent = {
  instruction: ViewInstruction,
  assigned: TaskViewAssignees,
  schedule: () => 'schedule',
  comments: TaskViewComments
}
